<div class="side_slider_cont" *ngIf="dataVolumeDiscount">
	<button class="close" (click)="closeVolumeDiscount()">
		<span class="material-symbols-outlined">close</span>
	</button>
	<div class="upper_slide_cont">
		<h3>
			{{dataVolumeDiscount.profileName}}
		</h3>
		<!-- <ng-container *ngFor="let vd of dataVolumeDiscount.volumeDiscountProfileItemList; let i = index">
			<p>
				<span>From {{vd.minimumOrderQuantity}} {{unit}}</span>
				<span>{{storeForex.selectedCurrencyName | uppercase}}
					{{discountCalculation(price, vd.discount) |  currencyConverter | number: '1.0-2'}} / {{unit}}</span>
			</p>
		</ng-container> -->

		<ng-container *ngFor="let vd of customVolumeDiscountList; let i = index">
			<p>
				<span>From {{vd.moq}} {{unit}}</span>
				<span>{{selectedCurrency | uppercase}}
					{{ vd.discountedPrice |  currencyConverter | number: '1.0-2'}} / {{unit}}</span>
			</p>
		</ng-container>


		<!-- <p>
			<span>From 1 meter:</span>
			<span>INR 400/ meter</span>
		</p>
		<p>
			<span>From 3 meter:</span>
			<span>INR 400/ meter</span>
		</p>
		<p>
			<span>From 10 meter:</span>
			<span>INR 400/ meter</span>
		</p>
		<p>
			<span>From 25 meter:</span>
			<span>INR 400/ meter</span>
		</p> -->
	</div>
	<div class="lower_slide_cont">
		<p>
			Disclaimer: {{dataVolumeDiscount.disclaimer}}
		</p>
	</div>
</div>
<div class="overlay_pop_up_pd" (click)="closeVolumeDiscount()"></div>
